import React from 'react';

import {Box, Center, Heading, VStack, useMediaQuery} from '@chakra-ui/react';

import {Navigate} from 'react-router-dom';

import {getAttribute, hasAccess} from '../../utils/user-access';
import {OrganizationPickerList} from '../OrganizationPickerList';
import {UserSession} from '../UserSession';
import {UserSessionMobile} from '../UserSessionMobile';
import {HeaderLayout} from './HeaderLayout';

export function InitLayout() {
  const [isLarge] = useMediaQuery('(min-width: 720px)');

  if (!hasAccess('super-admin')) {
    const organization = getAttribute<string[]>('organizations', [])[0];
    return <Navigate to={`/${organization}/home`} />;
  }

  return (
    <>
      <Box px='20px'>
        <HeaderLayout
          modeView='right'
          header={!isLarge ? <UserSessionMobile /> : <UserSession />}
        />
      </Box>
      <Center>
        <VStack>
          <Heading size='lg' my={8}>
            Happify Control
          </Heading>
          <OrganizationPickerList />
        </VStack>
      </Center>
    </>
  );
}
